import { Button, squareBlockCSS, styledOmitCustomProps, Typography } from '@braskai/ui-kit';

import { Box, css, List, styled } from '@mui/material';

export const SLinkContainer = styled(Box)(
  () => css`
    > a {
      height: 100%;
      display: block;
      overflow: hidden;
      text-decoration: none;
      line-height: 0;

      > svg {
        width: 128px;
        height: 24px;
      }
    }
  `,
);

export const SWhiteLabelIcon = styled(Box)(
  () => css`
    ${squareBlockCSS(32)};
    background: linear-gradient(137deg, #6a6aff 24.15%, #0b0bcf 100%);
    border-radius: 6px;
  `,
);

export const SWhiteLabelLogo = styled(Typography)(
  () => css`
    gap: 8px;
    white-space: nowrap;
    line-height: 17px;
  `,
);

type SListProps = {
  $flexGrow?: number;
};

export const SList = styled(
  List,
  styledOmitCustomProps,
)<SListProps>(
  ({ $flexGrow }) => css`
    padding: 8px;

    ${$flexGrow &&
    css`
      flex-grow: ${$flexGrow};
    `}
  `,
);

type SSidebarButtonProps = {
  $locked?: boolean;
};

export const SSidebarButton = styled(
  Button,
  styledOmitCustomProps,
)<SSidebarButtonProps>(
  ({ theme, $locked }) => css`
    ${squareBlockCSS(32)};
    border-radius: 6px;
    border: 1px solid transparent;
    padding: 7px;

    .MuiButton-icon svg {
      width: 16px;
      height: 16px;
      color: ${theme.palette.grey[700]};
    }

    &:hover,
    &:focus {
      background-color: ${theme.palette.grey[50]};

      .MuiButton-icon svg {
        color: ${theme.palette.grey[900]};
      }
    }

    ${$locked &&
    css`
      background-color: ${theme.palette.grey[50]};
      border-color: ${theme.palette.grey[100]};

      .MuiButton-icon svg {
        color: ${theme.palette.grey[900]};
      }
    `}
  `,
);
